'use strict';

angular.module('atex.dam').controller('DamFolderModalController', ['$scope', '$rootScope', '$q', 'ContentService', 'DamTemplateService', 'DamService', 'configuration','DamConfigurationService', '$translate', 'DamStatusService', 'DamMarkAsService','DamNotificationService', 'UIConfigurationService',
  function($scope, $rootScope, $q, ContentService, DamTemplateService, DamService, configuration, DamConfigurationService, $translate, DamStatusService, DamMarkAsService, DamNotificationService, UIConfigurationService) {
    $scope.panelTitle = $translate.getTranslationTable().__FOLDERS_NEW_DLG_TITLE__;
    $scope.loaded = false;
    $scope.showSpinner = true;
    $scope.article = atex.Content();
    $scope.isValid = false;

    var parentContentAccess;

    $scope.extScope = {
      parentId: $scope.parentId,
      privateFolder: {
        value: false
      },
      smartFolder: $scope.smartFolder,
      isNewFolder: true,
      queryModel: {
        sortValue: $rootScope.damSortData.currentSortValue,
        sortOrderValue: $rootScope.damSortData.currentSortOrderValue,
        includeTrash: "false",
        isDynamic: "false",
        viewMode : 'thumb-list',
        set:{}
      },

      properties: {
        hide: false,
        disabled: false,
      },

      changed: function () {
        $scope.dirty = true;
        $scope.checkIfValid();
      }
    };

    function info() {
      return ($scope.smartFolder) ? {name: "smart-folder", id: "desk-smart-folder", profile:"smart-folder-filters"} : {
        name: "folder",
        id: "desk-folder",
        profile:"folder-filters"
      };
    }

    function valid(field) {
      return (field && field.values && field.values.length > 0);
    }

    DamService.getCurrentDamUserInfo().then(function (currentUserInfo) {
      $scope.currentUserInfo = currentUserInfo;
      var template = $scope.smartFolder ? 'atex.dam.standard.Folder.smart' : 'atex.dam.standard.Folder';
      if (!$scope.parentId && !$scope.smartFolder) {
        template = 'atex.dam.standard.Folder.readonly';
      }

      DamTemplateService.getTemplateById(template).then(function (template) {
        $scope.template = angular.copy(template);
        $scope.article.template = $scope.template;

        if ($scope.parentId) {
          if ($scope.smartFolder) {
            $scope.panelTitle = $translate.getTranslationTable().__FOLDERS_NEW_SMART_DLG_TITLE__;
          }

          ContentService.getContent({id: $scope.parentId}).then(function (response) {
            $scope.article.data.aspects['p.InsertionInfo'] = angular.copy(response.data.aspects['p.InsertionInfo']);
            if (response.data.aspects['atex.Metadata']) {
              $scope.article.data.aspects['atex.Metadata'] = angular.copy(response.data.aspects['atex.Metadata']);
            } else {
              $scope.article.data.aspects['atex.Metadata'] = {
                data: {
                  _type: 'atex.Metadata',
                  taxonomyIds: ['p.StandardCategorization'],
                  metadata: {
                    _type: "com.polopoly.metadata.Metadata",
                    dimensions: []
                  }
                }
              };
            }

            parentContentAccess = angular.copy(response.data.aspects['atex.dam.standard.ContentAccess']);
            atex.onecms.ObjectUtils.accessor($scope.article.data, 'aspects/atex.OneCMS/data/createdWithTemplate').value = $scope.template.id;

            var _fields = atex.onecms.ObjectUtils.getByPath(response, "data/aspects/contentData/data/fields") || [];

            // Copy types, sources, iptc category from parent and limit them to the parent ones [max, gianluca]
            var keys = ["atex_desk_objectType", "source_atex_desk_s", "iptc_category_atex_desk_facet"];
            _.each(keys, function (key) {
              var _field = _.find(_fields, function (field) {
                return field.key === key;
              });

              if (!$scope.smartFolder && valid(_field)) {
                UIConfigurationService.draw(_field, info().name, info().id, info().profile).then(function (values) {
                  $scope.extScope.queryModel.set[_field.key] = values;
                  $scope.extScope.properties.hide = true;
                });
              }
            });

            var includeTrash = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/includeTrash').value;
            $scope.extScope.queryModel.includeTrash = angular.copy(includeTrash);

            var isDynamic = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/isDynamic').value;
            $scope.extScope.queryModel.isDynamic = angular.copy(isDynamic);

            var viewMode = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/viewMode').value || 'thumb-list';
            $scope.extScope.queryModel.viewMode = angular.copy(viewMode);

            $scope.loaded = true;
          }).then(null, function (error) {
            $scope.showSpinner = false;
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        } else {
          $scope.extScope.isNewFolder = false;
          $scope.extScope.properties.disabled = (!$scope.extScope.smartFolder && !$scope.extScope.isNewFolder);

          $scope.panelTitle = $translate.getTranslationTable().__FOLDERS_MODIFY_DLG_TITLE__;
          if ($scope.smartFolder) {
            $scope.panelTitle = $translate.getTranslationTable().__FOLDERS_MODIFY_SMART_DLG_TITLE__;
          }

          ContentService.getContent({id: $scope.id}).then(function (response) {
            var currentAssignees = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/atex.dam.standard.ContentAccess/data/assignees');
            $scope.extScope.privateFolder.value = currentAssignees && currentAssignees.value && currentAssignees.value.length === 1 && currentAssignees.value[0].externalId === currentUserInfo.externalId;
            $scope.article = angular.copy(response);

            // set the order
            var sortValue = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/sortValue').value;
            if (sortValue) {
              $scope.extScope.queryModel.sortValue = sortValue;
            }
            var sortOrderValue = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/sortOrderValue').value;
            if (sortOrderValue) {
              $scope.extScope.queryModel.sortOrderValue = sortOrderValue;
            }
            // set viewMode
            var viewMode = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/viewMode').value;
            if (viewMode) {
              $scope.extScope.queryModel.viewMode = viewMode;
            }

            var isDynamic = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/isDynamic').value;
            if (isDynamic) {
              $scope.extScope.queryModel.isDynamic = angular.copy(isDynamic);
            }

            var includeTrash = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/includeTrash').value;
            if (includeTrash) {
              $scope.extScope.queryModel.includeTrash = angular.copy(includeTrash);
            }

            var fields = atex.onecms.ObjectUtils.accessor(response.data, 'aspects/contentData/data/fields').value;

            if (fields) {
              $scope.extScope.queryModel.set = {};
              var promises = fields.map(function (field) {
                return UIConfigurationService.draw(field, info().name, info().id, info().profile).then(function (values) {
                  $scope.extScope.queryModel.set[field.key] = values;
                });
              });

              $q.all(promises).then(function () {
                $scope.checkIfValid();
                $scope.loaded = true;
                $scope.dirty = false;
              });
            }
          }).then(null, function (error) {
            $scope.showSpinner = false;
            var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
            DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
          });
        }
      }).then(null, function (error) {
        $scope.showSpinner = false;
        alert(error.cause);
      });
    });

    $scope.hideSpinner = function () {
      $scope.showSpinner = false;
    };

    function submit(cleanData) {
      var _field = atex.dam.AngularUtils.getTypeField(cleanData, "aspects/contentData/data/fields");

      var parentTypes = [];
      if (valid(_field) && $scope.smartFolder && $scope.selectedNode) {
        var types = _field.values;

        // Check if types are valid
        if ($scope.extScope.isNewFolder) {
          parentTypes = $scope.selectedNode.getAllowedTypes();
        } else if ($scope.selectedNode.parentNode) {
          parentTypes = $scope.selectedNode.parentNode.getAllowedTypes();
        }
        // Remove types that are not allowed
        if (parentTypes && parentTypes.length > 0) {
          for (var i = types.length - 1; i >= 0; i--) {
            if (_.indexOf(parentTypes, types[i]) === -1) {
              types.splice(i, 1);
            }
          }
        }
      }

      if (!valid(_field) && !$scope.smartFolder && $scope.selectedNode) {
        if ($scope.selectedNode.parentNode) {
          parentTypes = $scope.selectedNode.parentNode.getAllowedTypes();
          atex.dam.AngularUtils.addTypeField(angular.copy(parentTypes), cleanData, "aspects/contentData/data/fields");
        }
      }

      if ($scope.extScope.isNewFolder) {
        // Set the parentId
        cleanData.aspects.contentData.data.parentId = "contentid/" + $scope.parentId;
        var transferInfo = {
          data: cleanData
        };
        ContentService.createContent(transferInfo).then(function (response) {
          ContentService.getContent({id: response.id}).then(function (folder) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(folder);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          alert(error.cause);
        });
      } else {
        var updateInfo = {id: $scope.article.id, data: cleanData, revision: $scope.article.revision};
        ContentService.updateContent(updateInfo).then(function (response) {
          ContentService.getContent({id: response.id}).then(function (folder) {
            $scope.showSpinner = false;
            $scope.$parent.doOk(folder);
          });
        }).then(null, function (error) {
          $scope.showSpinner = false;
          alert(error.cause);
        });
      }
    }

    $scope.doSave = function () {
      $scope.showSpinner = true;
      $scope.article.data.aspects.contentData.data.objectType = "folder";
      var json = angular.toJson($scope.article.data);
      var cleanData = angular.fromJson(json);
      if ($scope.extScope.isNewFolder) {
        if ($scope.smartFolder) {
          cleanData.aspects.contentData.data.smartFolder = true;
        }

        if (parentContentAccess && !$scope.extScope.privateFolder.value) {
          cleanData.aspects['atex.dam.standard.ContentAccess'] = angular.copy(parentContentAccess);
        } else {
          cleanData.aspects['atex.dam.standard.ContentAccess'] = {
            data: {
              _type: 'atex.dam.standard.ContentAccess',
              "assignees": [
                {
                  "externalId": $scope.currentUserInfo.externalId,
                  "owner": "true"
                }
              ]
            }
          };
        }
        cleanData.aspects['atex.dam.standard.ContentAccess'].data.creator = $scope.currentUserInfo.externalId;
      }

      // set the order
      cleanData.aspects.contentData.data.sortValue = $scope.extScope.queryModel.sortValue;
      cleanData.aspects.contentData.data.sortOrderValue = $scope.extScope.queryModel.sortOrderValue;
      //set viewMode
      cleanData.aspects.contentData.data.viewMode = $scope.extScope.queryModel.viewMode;
      cleanData.aspects.contentData.data.includeTrash = angular.copy($scope.extScope.queryModel.includeTrash);
      cleanData.aspects.contentData.data.isDynamic = angular.copy($scope.extScope.queryModel.isDynamic);

      if ($scope.extScope.queryModel.set) {
        UIConfigurationService.commit($scope.extScope.queryModel, info().name, info().id, info().profile).then(function () {
          delete $scope.extScope.queryModel.set;
          cleanData.aspects.contentData.data.fields = $scope.extScope.queryModel.fields;

          var _fields = atex.onecms.ObjectUtils.getByPath(cleanData, "aspects/contentData/data/fields") || [];
          var _field = _.find(_fields, function (field) {
            return field.key === "tag_dimension.markas-iconcoding_ss";
          });

          var _values = atex.onecms.ObjectUtils.getByPath(_field, "values") || [];

          if (_values.length > 0) {
            if (_values[0] === "0") {
              _fields = _.without(_fields, _.findWhere(_fields, {
                key: 'tag_dimension.markas-iconcoding_ss'
              }));

              cleanData.aspects.contentData.data.fields = _fields;
            }
          }

          delete cleanData.aspects.contentData.data.fields_element_types;
          submit(cleanData);
        });
      } else {
        submit(cleanData);
      }
    };

    $scope.checkIfValid = function () {
      var name = atex.onecms.ObjectUtils.getByPath($scope.article, "data/aspects/contentData/data/name");

      if (name) {
        $scope.isValid = true;
      } else {
        $scope.isValid = false;
      }
    };

    $scope.changeEndCallback = function (data) {
      $scope.article.data = data;
      $scope.dirty = true;
      $scope.checkIfValid();
      $scope.$digest();
      return;
    };

    $scope.initCallback = function () {
    };

    $scope.changeStartCallback = function () {
    };

    $scope.isOkEnabled = function () {
      return !$scope.showSpinner && $scope.isValid && $scope.dirty;
    };
  } ]);